import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fea66d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label-icon-value-text-label"
}
const _hoisted_2 = {
  key: 1,
  class: "label-icon-value-text-icon"
}
const _hoisted_3 = {
  key: 2,
  class: "label-icon-value-text-label-value"
}
const _hoisted_4 = {
  key: 3,
  class: "label-icon-value-text-label-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.value != null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["label-icon-value-text-container",_ctx.variant])
      }, [
        (!_ctx.hideLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.label) + ":", 1)
              ], true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hideIcon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, { size: "35" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.cloudIcon(_ctx.value)), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hideValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(Math.ceil(_ctx.value * 100)) + " % ", 1))
          : _createCommentVNode("", true),
        (!_ctx.hideText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.getText(_ctx.value)[1]), 1))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}